import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';

import './assets/styles/style.css';
import './i18n';
import store from './store';
import App from './App';
import './index.css';
import './styles/globals.css';
import { ThemeProvider } from './components/ThemeProvider';

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider defaultTheme="system" storageKey="ui-theme">
      <Suspense fallback={<div>Loading...</div>}>
        <App />
        <Toaster
          position="top-right"
          gutter={10}
          toastOptions={{
            duration: 4000,
            style: {
              background: 'hsl(var(--card))',
              color: 'hsl(var(--foreground))',
              border: '1px solid hsl(var(--border))',
              borderRadius: '0.625rem',
              padding: '10px 14px',
              fontSize: '0.875rem',
              fontWeight: 500,
              maxWidth: '24rem',
              boxShadow:
                '0 4px 12px -2px rgb(0 0 0 / 0.08), 0 2px 4px -2px rgb(0 0 0 / 0.04)',
            },
            success: {
              iconTheme: {
                primary: 'hsl(158 64% 42%)',
                secondary: 'hsl(0 0% 100%)',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: 'hsl(0 72% 51%)',
                secondary: 'hsl(0 0% 100%)',
              },
            },
          }}
        />
      </Suspense>
    </ThemeProvider>
  </Provider>,
);
